import {
  Component,
  ElementRef,
  Host,
  Inject,
  Input,
  Optional,
  QueryList,
  ContentChildren,
  HostBinding,
} from '@angular/core';

import { TiSplitterService } from './ti.splitter.service';
import { SplitterComponent } from '../../../../../kendo/kendo-angular-layout/splitter/splitter.component';
import { LocalizationService, L10N_PREFIX } from '@progress/kendo-angular-l10n';
import { Orientation } from '../../../../../kendo/kendo-angular-layout/common/orientation';

import { TiSplitterPaneComponent } from './ti.splitter-pane.component';

@Component({
  standalone: false,
  exportAs: 'tiKendoSplitter',
  selector: 'ti-kendo-splitter, kendo-splitter',
  providers: [
    TiSplitterService,
    LocalizationService,
    {
      provide: L10N_PREFIX,
      useValue: 'kendo.spliter',
    },
  ],
  template: `
    <ng-content select="ti-kendo-splitter-pane, kendo-splitter-pane"></ng-content>
    <ng-container *ngFor="let pane of panes; let index = index; let last = last">
      <ti-kendo-splitter-bar
        kendoLayoutDraggable
        *ngIf="!last"
        [index]="index"
        [containerIndex]="pane.containerId + '-' + index"
        [orientation]="orientation">
      </ti-kendo-splitter-bar>
    </ng-container>
  `,
})
export class TiSplitterComponent extends SplitterComponent {
  @HostBinding('class.ti-splitter')
  @Input()
  public orientation: Orientation;

  @ContentChildren(TiSplitterPaneComponent)
  public panes: QueryList<TiSplitterPaneComponent>;

  constructor(
    element: ElementRef,
    splitterService: TiSplitterService,
    localization: LocalizationService,
    @Optional() @Host() @Inject(TiSplitterPaneComponent) enclosingPane?: TiSplitterPaneComponent,
  ) {
    super(element, splitterService, localization, enclosingPane);
  }
}
